export const HEADER_TITLE = 'Confirm Your Unit Settings'
export const BODY_TEXT =
  'The Recognizing Bullying & Harassment unit for Grades 6—8 can be enabled or disabled.'
export const STATUS_TEXT = 'Recognizing Bullying & Harassment Unit:'
export const SETTING_BUTTON_TEXT = 'Unit Settings'
export const DISMISS_BUTTON_TEXT = 'Dismiss'
export const LINK_TEXT = "See What's Changing"
export const COOKIE_NAME = 'MspBullyingNotificationDismissed'
